<a mat-icon-button color="primary" href="https://franciliane.cegedim.com/HEAT/Modules/SelfService/#home"
  target="_blank" matTooltip="Ouvrir un ticket LUCI">
  <img src="assets/icon/ticket.png">
</a>